import React, { useState, useEffect } from "react"
import axios from "axios"
import { connect } from "react-redux"
import { Button, Menu, MenuItem } from "@material-ui/core";
import { Link } from "react-router-dom"
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ExpandMore from '@material-ui/icons/ExpandMore';

import Header from "../../ui/Header"
import Container from "../../ui/Container"
import LoaderSpinner from "../../ui/Loader"
import ProductCard from "../../ui/ProductCard";
import PageTitle from "../../ui/PageTitle";
import "../Collection/Collection.css";

const sortString = {
    "descending": {
        "ua": "За ціною (спочатку дорожчі)",
        "ru": "За ценой (сначала дороже)",
    },
    "ascending": {
        "ua": "За ціною (спочатку дешевші)",
        "ru": "За ценой (сначала дешевле)"
    },
    "alphabetical": {
        "ua": "За назвою",
        "ru": "По названию"
    }
}

const Promotions = ({ match, translation, ...props }) => {
    const [promotionsPage, setPromotionsPage] = useState({
        count: 0,
        pageSize: 10,
        products: []
    })

    const [page, setPage] = useState(parseInt(new URLSearchParams(props.location.search).get('page')) || 0)
    const [sort, setSort] = useState("descending")
    useEffect(() => {
        setPage(parseInt(new URLSearchParams(props.location.search).get('page')) || 0)
        window.scrollTo(0, 0)
    }, [props.location.search])
    const [loaded, setLoaded] = useState(true)

    const [menuAnchor, setMenuAnchor] = useState(null)

    const applySort = s => {
        setSort(s)
        setMenuAnchor(null)
    }

    useEffect(() => {
        axios(`/with_discount/?page=${page}&sort=${sort}&language=${translation.language}`).then(res => {
            setPromotionsPage(res.data)
            setLoaded(false)
        })
    }, [page, sort, translation.language])

    const paginatorDifference = () => promotionsPage.count - promotionsPage.pageSize * (page + 1)

    if (!promotionsPage) {
        return (
            <div className="Collection">
                <Header />
                <div className={`${loaded ? "Collection-spinner" : "Collection-spinner-off"}`}>
                    <LoaderSpinner visible={loaded} />
                </div>
            </div>
        )
    }

    return (
        <div className="Collection">
            <Header />
            <div className="Collection--category">
                <PageTitle
                    title={translation.language === "ua" ? "Акційні товари" : "Акционные товары"}
                />
                <Container>
                    <div className="Collection--category--actions">
                        <div className="Collection--category--action Collection--category--sort">
                            <span className="Collection--category--filter--name" id="promotions-sort-label">
                                {translation.language === "ua" && "Сортування"}
                                {translation.language === "ru" && "Сортировка"}
                            </span>
                            <Button
                                variant="outlined"
                                onClick={e => setMenuAnchor(e.currentTarget)}
                                endIcon={<ExpandMore />}
                                aria-haspopup="true"
                                aria-expanded={Boolean(menuAnchor)}
                                aria-describedby="promotions-sort-label"
                                className="Collection--select"
                            >
                                {sortString[sort][translation.language]}
                            </Button>
                            <Menu
                                anchorEl={menuAnchor}
                                open={Boolean(menuAnchor)}
                                onClose={() => setMenuAnchor(null)}
                                getContentAnchorEl={null}
                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                transformOrigin={{ vertical: "top", horizontal: "left" }}
                                classes={{ paper: "Collection--menu" }}
                            >
                                <MenuItem selected={sort === "descending"} onClick={() => applySort("descending")}>
                                    {sortString["descending"][translation.language]}
                                </MenuItem>
                                <MenuItem selected={sort === "ascending"} onClick={() => applySort("ascending")}>
                                    {sortString["ascending"][translation.language]}
                                </MenuItem>
                                <MenuItem selected={sort === "alphabetical"} onClick={() => applySort("alphabetical")}>
                                    {sortString["alphabetical"][translation.language]}
                                </MenuItem>
                            </Menu>
                        </div>
                    </div>
                    <div className="Collection--items">
                        {promotionsPage.products.map(product => (
                            <ProductCard
                                key={product.id}
                                translation={translation}
                                product={product}
                            />
                        ))}
                    </div>
                </Container>
            </div>
            <Container>
                <nav className="Collection--paginator" aria-label={translation.language === "ua" ? "Сторінки" : "Страницы"}>
                    {page > 0 &&
                        <Link className="Collection--paginator--previous" to={`/promotions/?page=${page - 1}`}>
                            <ArrowBackIcon fontSize="small" />
                            {translation.language === "ua" && "Попередня"}
                            {translation.language === "ru" && "Предыдущая"}
                        </Link>
                    }
                    {(page > 0 || paginatorDifference() > 0) &&
                        <span className="Collection--paginator--page">
                            {translation.language === "ua" ? "Сторінка " : "Страница "}{page + 1}
                        </span>
                    }
                    {paginatorDifference() > 0 &&
                        <Link className="Collection--paginator--next" to={`/promotions/?page=${page + 1}`}>
                            {translation.language === "ua" && "Наступна"}
                            {translation.language === "ru" && "Следующая"}
                            <ArrowForwardIcon fontSize="small" />
                        </Link>
                    }
                </nav>
            </Container>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        translation: state.translationReducer,
    }
}

export default connect(mapStateToProps)(Promotions)